import "../CSS/invoice/invoiceThermal.css"
import { useParams, useLocation } from "react-router-dom"
import { useState, useEffect } from 'react'
import api from '../Services/api'
import { Spinner } from 'react-bootstrap';
import { format } from "../Utilities/Currency";
import { Link } from 'react-router-dom'

//Component for Invoice Thermal
const InvoiceThermal = () => {
    
  const { orderUUID } = useParams();
  const location = useLocation();
  const [ orderData, setOrderData ] = useState();
  const [ relatedOrderData, setRelatedOrderData ] = useState([]);
  const [ isLoading, setIsLoading ] = useState(true);

  useEffect(() => {
    const fetchMainOrder = api.get(`/data/order/${orderUUID}/`);

    const relatedOrders = location.state?.relatedOrders || [orderUUID];
    const otherOrderUUIDs = relatedOrders.filter(uuid => uuid !== orderUUID);

    const fetchRelatedOrders = otherOrderUUIDs.map(uuid =>
      api.get(`/data/order/${uuid}/`)
    );

    Promise.all([fetchMainOrder, ...fetchRelatedOrders])
      .then(responses => {
        const mainOrder = responses[0].data;
        const relatedOrders = responses.slice(1).map(r => r.data);
        
        setOrderData(mainOrder);
        setRelatedOrderData(relatedOrders);
        setIsLoading(false);
      })
      .catch(err => {
        console.error('Error fetching orders:', err);
        setIsLoading(false);
      });
  }, [orderUUID, location.state]);

  if (isLoading) {
    return (
      <Spinner className="spinner" animation="border" role="status" size="xl">
        <span className="visually-hidden">Loading...</span>
      </Spinner>
    );
  }

  // Fetch failed (expired session / network error) -> orderData is undefined.
  // Render a safe message instead of crashing on orderData.uuid / .note below.
  if (!orderData) {
    return (
      <div className="d-print-none" style={{ padding: '2rem', textAlign: 'center' }}>
        <p>Gagal memuat invoice. Silakan muat ulang halaman atau masuk kembali.</p>
      </div>
    );
  }

  const formatDisplayId = (displayId) => {
  if (!displayId && displayId !== 0) return "";
  const asString = `${displayId}`;
  const suffix = asString.slice(-3).padStart(3, "0");
  const prefix = asString.slice(0, -3);
  return prefix ? `${prefix}-${suffix}` : suffix;
};

  // Helper function to render a single thermal receipt
  const renderThermalReceipt = (order, invoiceType = '') => {
    const date = new Date(order.datetime_created).toISOString().split('T')[0]
    const isThisTaxInvoice = order.note?.includes('Dengan Pajak');
    
    const items = []
    let total = 0
    
    for (var orderItem of order.order_items) {
      // Use regular price for all invoices
      let basePrice = orderItem.price_per_unit;
      
      // Calculate price after discount
      const finalPrice = basePrice - (basePrice * (orderItem.discount || 0) / 100);
      const subtotal = orderItem.pcs * finalPrice;
      
      const invoiceThermalItem = (
        <div className="my-2" key={`${order.id}-${orderItem.product.id}`}>
          <div className="d-flex justify-content-between">
            <div className="item-name text-left">
              {orderItem.product.name}
            </div>
            <div className="discount text-right">{ orderItem.discount > 0 ? `-${orderItem.discount}%` : '-' }</div>
          </div>
          <div className="d-flex justify-content-between">
            <div className="item-total">{orderItem.pcs}x {format(basePrice)}</div>
            <div className="item-total-price text-right">{format(subtotal)}</div>
          </div>
        </div>
      )

      items.push(invoiceThermalItem)
      total += subtotal
    }

    return (
      <div key={`receipt-${order.id}`} className="receipt">
        <header>
          <h1>Superjaya</h1>
          <p className="mb-0">Samarinda</p>
          <p className="my-0">WA/Telp: +628135050771</p>
          {invoiceType && (
            <p className="my-0 font-weight-bold">{invoiceType}</p>
          )}
        </header>
        <table className="mytable">
          <tbody>
            <tr>
              <td>{date}</td>
              <td>#{formatDisplayId(orderData.display_id)}</td>
              <td>{order.handler_name}</td>
            </tr>
          </tbody>
        </table>

        {items}

        <div className="d-flex justify-content-end mb-3" style={{borderTop: "1px dashed black", borderBottom: "1px dashed black"}}>
          <p className="my-0">Total: {format(total)}</p>
        </div>

        <footer>info@Superjaya.id</footer>
      </div>
    )
  }

  return (
    <>
      <div className="container px-0 invoice-actions-container d-print-none" style={{ 'maxWidth': '850px' }}>
        <Link className='btn action-button mx-2 d-print-none' to={`/invoice/${orderData.uuid}`}>Non-Thermal</Link>
        <button className='btn action-button mx-2 d-print-none' onClick={window.print}>Print All</button>
        {relatedOrderData.length > 0 && (
          <div className="alert alert-info mt-2">
            <strong>📄 Invoices terpisah:</strong> Produk dengan pajak dan tanpa pajak telah dipisahkan menjadi {relatedOrderData.length + 1} invoice berbeda.
          </div>
        )}
      </div>
      
      {/* Main Receipt */}
      {renderThermalReceipt(
        orderData,
        relatedOrderData.length > 0 ? (orderData.note?.includes('Dengan Pajak') ? 'INVOICE DENGAN PAJAK' : 'INVOICE TANPA PAJAK') : ''
      )}
      
      {/* Related Receipts */}
      {relatedOrderData.map((relatedOrder, index) => (
        <div key={`related-${index}`}>
          <div className="page-break d-print-block" style={{pageBreakBefore: 'always', marginBottom: '20px'}}></div>
          {renderThermalReceipt(
            relatedOrder,
            relatedOrder.note?.includes('Dengan Pajak') ? 'INVOICE DENGAN PAJAK' : 'INVOICE TANPA PAJAK'
          )}
        </div>
      ))}
    </>
  )
}

export default InvoiceThermal